import { Model } from "@bryntum/schedulerpro";
import {TASK_BUDGET_FIELDS} from "../../other/constants/OtherKeys.jsx";
import { HasProjectMixin } from "./mixins/HasProjectMixin.jsx";
import { getAging } from "../../other/utils/utils.jsx";

export class TaskBudget extends HasProjectMixin(Model) {
  static get $name() {
    return "TaskBudget";
  }

  static get fields() {
    return [
      // Cannot use budget id as name because it will cause issue when assigning budgetId to task
      { name: TASK_BUDGET_FIELDS.title, dataSource: "budget_id" },
      { name: TASK_BUDGET_FIELDS.description, dataSource: "description" },
      { name: TASK_BUDGET_FIELDS.contractAmount, dataSource: "contract_amount", type: "number" },
      { name: TASK_BUDGET_FIELDS.changeOrders, dataSource: "change_orders", type: "number" },
      { name: TASK_BUDGET_FIELDS.totalContract, dataSource: "total_contract" },
      { name: TASK_BUDGET_FIELDS.totalCostEstimated, dataSource: "total_cost_estimated" },
      { name: TASK_BUDGET_FIELDS.totalCostActual, dataSource: "total_cost_actual" },
      { name: TASK_BUDGET_FIELDS.totalCostVariance, dataSource: "total_cost_variance" },
      { name: TASK_BUDGET_FIELDS.grossProfitEstimated, dataSource: "gross_profit_estimated" },
      { name: TASK_BUDGET_FIELDS.grossProfitActual, dataSource: "gross_profit_actual" },
      { name: TASK_BUDGET_FIELDS.grossProfitVariance, dataSource: "gross_profit_variance" },
      { name: TASK_BUDGET_FIELDS.grossMarginEstimated, dataSource: "gross_margin_estimated", type: "number" },
      { name: TASK_BUDGET_FIELDS.grossMarginActual, dataSource: "gross_margin_actual", type: "number" },
      { name: TASK_BUDGET_FIELDS.grossMarginVariance, dataSource: "gross_margin_variance", type: "number" },
      { name: TASK_BUDGET_FIELDS.laborEstimated, dataSource: "labor_estimated", type: "number" },
      { name: TASK_BUDGET_FIELDS.laborActual, dataSource: "labor_actual", type: "number" },
      { name: TASK_BUDGET_FIELDS.laborVariance, dataSource: "labor_variance" },
      { name: TASK_BUDGET_FIELDS.materialsEstimated, dataSource: "materials_estimated", type: "number" },
      { name: TASK_BUDGET_FIELDS.materialsActual, dataSource: "materials_actual", type: "number" },
      { name: TASK_BUDGET_FIELDS.materialsVariance, dataSource: "materials_variance" },
      { name: TASK_BUDGET_FIELDS.subsEstimated, dataSource: "subs_estimated", type: "number" },
      { name: TASK_BUDGET_FIELDS.subsActual, dataSource: "subs_actual", type: "number" },
      { name: TASK_BUDGET_FIELDS.subsVariance, dataSource: "subs_variance" },
      { name: TASK_BUDGET_FIELDS.rentalsEstimated, dataSource: "rentals_estimated", type: "number" },
      { name: TASK_BUDGET_FIELDS.rentalsActual, dataSource: "rentals_actual", type: "number" },
      { name: TASK_BUDGET_FIELDS.rentalsVariance, dataSource: "rentals_variance" },
      { name: TASK_BUDGET_FIELDS.miscellaneousEstimated, dataSource: "miscellaneous_estimated", type: "number" },
      { name: TASK_BUDGET_FIELDS.miscellaneousActual, dataSource: "miscellaneous_actual", type: "number" },
      { name: TASK_BUDGET_FIELDS.miscellaneousVariance, dataSource: "miscellaneous_variance" },
      { name: TASK_BUDGET_FIELDS.updatedAt, dataSource: "updated_at" },
      { name: TASK_BUDGET_FIELDS.daysEstimated, dataSource: "days_estimated", type: "number" },
      { name: TASK_BUDGET_FIELDS.daysActual, dataSource: "days_actual" },
      { name: TASK_BUDGET_FIELDS.daysVariance, dataSource: "days_variance" },
      { name: TASK_BUDGET_FIELDS.updatedFields, dataSource: "updated_fields" },
      { name: TASK_BUDGET_FIELDS.createdAt, dataSource: "created_at", type: "date" },
      { name: "updaterId", dataSource: "updater", type: "number" },
      // Todo: Create mixin for archive field
      { name: "archived", type: "boolean", dataSource: "archived" },
    ]
  }

  get budgetTasks() {
    if (this.project) {
      return this.project.extraTaskStore.query((task) => task.budgetId === this.id, true);
    }
    return [];
  }

  get archived() {
    return this.get("archived");
  }

  set archived(value) {
    /* If budget is being archived, then delink all tasks */
    if (value) {
      this.budgetTasks.forEach((task)=> {
        task.budgetId = null;
      })
    }
    this.set("archived", value);
  }

  get [TASK_BUDGET_FIELDS.budgetTitleDisplayValue]() {
    const titleValue = this.get([TASK_BUDGET_FIELDS.title]);
    const descriptionValue = this.get([TASK_BUDGET_FIELDS.description]);
    let value = titleValue || "";
    if (descriptionValue?.length) value = `${value} - ${descriptionValue}`
    return value.trim();
  }

  get budgetTasksValues() {
    return (this.budgetTasks || []).map((task) => task.name);
  }

  get entityVisibleName() {
    return "Budget"
  }

  get aging() {
    return getAging(this.get("createdAt"));
  }

  get updaterName() {
    if (this.project) {
      return this.project.boardUsersStore.getById(this.updaterId)?.name
    }
    return null;
  }
}

TaskBudget.exposeProperties();
